module.exports = __webpack_public_path__ + "img/two-dimensional code@3x.7a65eeee.png";